import api from '@/shared/utils/apiConfig';

export interface UserSessionItem {
  id: string;
  ip?: string;
  userAgent?: string;
  createdAt: string;
  lastSeenAt: string;
  expiresAt: string;
  revokedAt?: string;
  isCurrent: boolean;
}

export async function listMySessions(): Promise<UserSessionItem[]> {
  const res = await api.get<{ success: boolean; data: UserSessionItem[] }>('/auth/sessions');
  return res.data.data || [];
}

export async function revokeMySession(
  sessionId: string
): Promise<{ currentSessionRevoked: boolean }> {
  const res = await api.delete<{
    success: boolean;
    data: { currentSessionRevoked: boolean };
  }>(`/auth/sessions/${sessionId}`);
  return res.data.data;
}

export async function revokeOtherSessions(): Promise<{ revokedCount: number }> {
  const res = await api.post<{ success: boolean; data: { revokedCount: number } }>(
    '/auth/sessions/revoke-others',
    {}
  );
  return res.data.data;
}

export async function logoutSession(): Promise<void> {
  await api.post('/auth/logout', {});
}

export async function adminRevokeUserSessions(
  userId: string
): Promise<{ revokedCount: number }> {
  const res = await api.post<{ success: boolean; data: { revokedCount: number } }>(
    `/users/${userId}/revoke-sessions`,
    {}
  );
  return res.data.data;
}
